module.exports = __webpack_public_path__ + "img/q1.363f1729.png";